module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"label":"Pagar via PIX","error":"Não conseguimos gerar o pagamento. Verifique sua internet e clique no botão abaixo para tentar novamente."}}')
  delete Component.options._Ctor
}
